export type MBoxKeys = "mbox-favorites-teste-exemplo";

export const MBOXES: Partial<Record<MBoxKeys, { contentKey: string }>> = {};
